import { Typography } from "@graphy/ui";
import Image from "next/image";
import { useRouter } from "next/router";

export type featureCardType = {
  title: string;
  description: string;
  image: string;
  mwebImage?: string;
  link: string;
  classes: string;
};

interface FeatureCardProps {
  card: featureCardType;
}

export const FeatureCard = ({ card }: FeatureCardProps) => {
  const { title, description, link, image, classes } = card;
  const router = useRouter();

  return (
    <div
      className={`group relative cursor-pointer rounded-3xl border border-transparent  bg-grey-1 p-4 transition-all duration-300 hover:-translate-y-2 hover:border-purple-2   hover:shadow-purpleShadow ${classes}  flex  h-full flex-col`}
      onClick={() => link && router.push(link)}
    >
      {link && <Image
        src="/images/arrow-purple.svg"
        alt={title + "link"}
        width={24}
        height={24}
        className="absolute right-4 top-4 opacity-0 transition-opacity group-hover:opacity-100"
      />}
      <div className="relative mx-auto my-auto h-full w-full">
        <Image
          src={image}
          alt={title}
          fill
          className={`${card.mwebImage ? "hidden md:block" : ""} mx-auto`}
        />
        {card.mwebImage && (
          <Image
            src={card.mwebImage}
            alt={title}
            fill
            className="mx-auto md:hidden"
          />
        )}
      </div>
      <div className="mt-1">
        <Typography className="mb-1 text-xl font-semibold text-grey-4">
          {title}
        </Typography>
        <Typography size={"BODY"} colorClass="text-grey-3">
          {description}
        </Typography>
        {}
      </div>
    </div>
  );
};
